import type { CityConfig } from "../city-template/types";

export const boulderCityConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Nevada Dept of Health Vital Records", href: "https://dpbh.nv.gov/Programs/VitalRec/", description: "Official Nevada vital records office in Carson City" },
    { label: "Marriage Licenses — Clark County Clerk", href: "https://www.clarkcountynv.gov/", description: "Clark County Clerk — marriage license issuance" },
    { label: "Divorce Records — Clark County Clerk", href: "https://www.clarkcountynv.gov/", description: "Clark County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NV DOH for online vital record orders" },
  ],
  city: "Boulder City",
  state: "Nevada",
  stateAbbr: "NV",
  slug: "boulder-city",
  route: "/boulder-city",
  title: "Emergency Passport Boulder City NV | Expedited Passport Renewal Clark County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport renewal in Boulder City, NV — as fast as 24 hours. Fast passport services for Boulder City, Lake Mead, and southern Clark County travelers. A+ BBB rated, registered State Dept. courier. No agency visit required.",
  h1: "Emergency & Expedited Passport Services in Boulder City, NV",
  heroSubtitle: "Passport expired before your trip from the Lake Mead area? Fast Passport Center helps Boulder City and southern Clark County travelers get expedited passports in as little as 24 hours. No agency visit required — Nevada has no local passport agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Boulder%20City%20Nevada%20historic%20downtown%20district%20along%20Nevada%20Way%20with%20Lake%20Mead%20and%20desert%20mountain%20landscape%20visible%20in%20the%20background%2C%20Hoover%20Dam%20area%20context%2C%20peaceful%20small%20town%20atmosphere%20with%20vintage%20streetlamps%20and%20Southwestern%20architecture%2C%20clear%20Nevada%20blue%20sky%20with%20bright%20desert%20afternoon%20sunlight%2C%20wide%20panoramic%20view%20of%20the%20scenic%20Mojave%20Desert%20setting%2C%20clean%20townscape%20photography%20with%20Henderson%20foothills%20in%20distance%2C%20no%20text%20or%20people%20visible&width=1800&height=700&seq=boulder-city-nv-hero-001&orientation=landscape",
  heroImageAlt: "Boulder City Nevada downtown with Lake Mead and desert mountain landscape backdrop",
  geoPosition: "35.9786;-114.8343",
  geoPlacename: "Boulder City, Nevada",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "95 Hawthorne St, Suite 600, San Francisco, CA 94105",
    distance: "Located in San Francisco — approximately 550 miles from Boulder City via I-15 and I-5",
  },
  nearbyCitiesZips: [
    { name: "Boulder City", zips: "89005, 89006" },
    { name: "Henderson", zips: "89002, 89011, 89012, 89014, 89015, 89044, 89052, 89074" },
    { name: "Lake Mead NRA", zips: "89005" },
    { name: "Hoover Dam / Willow Beach", zips: "86445" },
    { name: "Nelson / Searchlight", zips: "89046" },
    { name: "Laughlin", zips: "89028, 89029" },
    { name: "Las Vegas", zips: "89101, 89102, 89103, 89104" },
    { name: "Green Valley", zips: "89074" },
    { name: "Anthem", zips: "89052" },
    { name: "Cadence", zips: "89011" },
    { name: "Kingman (AZ)", zips: "86401, 86409" },
    { name: "Bullhead City (AZ)", zips: "86442" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Boulder City and Lake Mead area departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS in Boulder City or Henderson" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Henderson", route: "/henderson-nv" },
    { name: "Fast passport renewal in Las Vegas", route: "/las-vegas" },
    { name: "Expedited passport help in Laughlin", route: "/laughlin" },
    { name: "Urgent passport services in Los Angeles", route: "/los-angeles" },
    { name: "Same-day passport help in San Francisco", route: "/san-francisco" },
    { name: "Passport courier services in Southern Nevada", route: "/nevada" },
  ],
  fpcOfficeAddress: "100 W Liberty St, Reno, NV 89501",
  fpcOfficeNote: "Fast Passport Center serves Boulder City remotely via secure overnight courier. We do not have a walk-in office in Boulder City — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Boulder City and southern Clark County residents.",
  fpcOfficeDistance: "Serving all of Boulder City, Lake Mead area, and southern Clark County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Boulder City and the Lake Mead region. As Nevada's only incorporated city that prohibits gambling — this historic Boulder Dam town has a strong retiree community, outdoor recreation culture, and growing number of international travelers. We serve everyone from downtown Boulder City to the Lake Mead Marina communities.",
  nearbyCitiesIntro: "We serve all Boulder City neighborhoods and nearby communities including Henderson, Lake Mead NRA, Hoover Dam, Nelson, Searchlight, Willow Beach, and the broader southern Clark County area. Our overnight shipping labels work from any UPS location — your desert location doesn't slow us down.",
  howItWorksIntro: "Most Boulder City travelers complete everything online and ship documents overnight. No need to drive to San Francisco, Los Angeles, or even Las Vegas. Our emergency passport process delivers fast results for southern Nevada travelers.",
  mistakesIntro: "Boulder City and southern Clark County residents often underestimate how far the nearest passport agency is. Here are the most common passport mistakes we see.",
  testimonialsIntro: "Boulder City and Lake Mead area travelers trust us when their international departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Boulder City? Here are the most common ones we hear from southern Clark County travelers.",
  statePageRoute: "/states/nevada",
  statePageName: "Nevada",
  dmvWebsite: "https://dmv.nv.gov",
  dmvLabel: "Nevada DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Nearest agency is San Francisco (550 miles) or Los Angeles (300 miles)",
        "Expect long travel times through desert highways",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Boulder City travelers with immediate departure needs — as fast as 24 hours for urgent flights from Harry Reid International Airport in Las Vegas.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Boulder City adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance for Boulder City and southern Clark County residents.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance — especially important for travelers who lose passports at Lake Mead recreation areas.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Boulder City Nevada travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Boulder City NV and southern Clark County." },
    { name: "New Passport", description: "First-time passport application assistance for Boulder City and Lake Mead area residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia M.",
      location: "Boulder City, NV",
      rating: 5,
      text: "Retired couple planning a river cruise in Europe. My husband's passport was expired and we had 10 days until departure. Fast Passport Center renewed it in 2 days. We made our dream cruise!",
      service: "Passport Renewal",
    },
    {
      name: "Roger K.",
      location: "Boulder City, NV",
      rating: 5,
      text: "I work at Hoover Dam and needed a quick passport for a work trip to Brazil. They turned it around in 48 hours flat. Incredibly professional service for a small town.",
      service: "Emergency Passport",
    },
    {
      name: "Diana S.",
      location: "Boulder City, NV",
      rating: 5,
      text: "My daughter's first passport for a summer study abroad program. We were nervous about the process but they guided us through every step. Passport arrived in 5 days.",
      service: "New Passport",
    },
    {
      name: "Larry T.",
      location: "Henderson, NV",
      rating: 5,
      text: "Live near Anthem and use Boulder City facilities. Lost my passport boating on Lake Mead — they replaced it in 48 hours. Couldn't believe how fast it was.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "bouldercity-1",
      name: "Boulder City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1100 Colorado St",
      city: "Boulder City",
      state: "NV",
      zip: "89005",
      phone: "(702) 293-7978",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Boulder City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Boulder City facility. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "bouldercity-2",
      name: "Henderson Post Office — Green Valley",
      type: "USPS Passport Acceptance Facility",
      address: "2722 N Green Valley Pkwy",
      city: "Henderson",
      state: "NV",
      zip: "89014",
      phone: "(702) 454-1670",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Boulder City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility in Green Valley. Serves Henderson and Boulder City residents. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "bouldercity-3",
      name: "Henderson City Hall",
      type: "City Clerk Passport Acceptance",
      address: "240 S Water St",
      city: "Henderson",
      state: "NV",
      zip: "89015",
      phone: "(702) 267-1400",
      hours: "Mon–Fri: 7:30 AM – 5:30 PM",
      distance: "15 miles north of Boulder City",
      website: "https://www.cityofhenderson.com/",
      websiteLabel: "City of Henderson",
      notes: "Full-service city facility with passport acceptance. Extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "bouldercity-4",
      name: "Hillcrest Post Office — Henderson",
      type: "USPS Passport Acceptance Facility",
      address: "3680 N Green Valley Pkwy",
      city: "Henderson",
      state: "NV",
      zip: "89014",
      phone: "(702) 558-5765",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "16 miles north of Boulder City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative Henderson facility near the I-215 beltway. Convenient for Boulder City residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bouldercity-5",
      name: "Laughlin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2850 S Needles Hwy",
      city: "Laughlin",
      state: "NV",
      zip: "89029",
      phone: "(702) 298-2120",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles south of Boulder City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Laughlin and southern Clark County. Alternative for Boulder City south side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bouldercity-6",
      name: "Nevada DMV — Henderson",
      type: "State DMV Acceptance Facility",
      address: "1399 American Pacific Dr",
      city: "Henderson",
      state: "NV",
      zip: "89074",
      phone: "(702) 486-4368",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "15 miles from Boulder City",
      website: "https://dmv.nv.gov/",
      websiteLabel: "Nevada DMV",
      notes: "Full-service Henderson DMV. REAL ID and driver's license services. Appointment required.",
      icon: "ri-car-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 300+ miles to nearest agency", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Boulder City photo options are limited — make sure your photos are exactly 2×2 inches with a white or off-white background before visiting the post office.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Boulder City and Henderson acceptance facilities.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Underestimating Agency Distance",
      description: "The nearest passport agency is the Los Angeles Passport Agency, about 300 miles away. The San Francisco Agency is 550 miles. For most Boulder City travelers, using our courier service eliminates long desert drives entirely.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Los Angeles or San Francisco regional agencies will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Boulder City families at the acceptance clerk at the small post office.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Nevada has no local passport agency. Standard processing takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Boulder City or Henderson." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Boulder City address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Boulder City, NV?",
      a: "Fast Passport Center offers emergency passport processing in Boulder City in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities. Nevada has no local passport agency — the nearest is Los Angeles (300 miles) or San Francisco (550 miles) — so our courier service is the fastest, most practical option for Boulder City travelers.",
    },
    {
      q: "What is the nearest passport agency to Boulder City?",
      a: "The Los Angeles Passport Agency is approximately 300 miles southwest via I-15, and the San Francisco Passport Agency is about 550 miles away. Most Boulder City travelers find it far more practical to use Fast Passport Center's 24–48 hour courier service rather than making the long desert drive — especially during summer when temperatures can exceed 110°F.",
    },
    {
      q: "Does Boulder City have passport acceptance facilities?",
      a: "Yes. The Boulder City Post Office at 1100 Colorado St offers passport acceptance services by appointment. For larger facilities, both Green Valley and Hillcrest Post Offices in Henderson are about 15 miles north, and the Henderson City Hall offers full services with extended hours. We recommend calling ahead to confirm availability.",
    },
    {
      q: "Do you serve the Lake Mead National Recreation Area?",
      a: "Yes. Fast Passport Center serves all communities around Lake Mead including Willow Beach, Cottonwood Cove, Temple Bar, and the Lake Mead Marina areas. Our overnight shipping labels work from any UPS location, so even if you're at the lake or in a remote part of the recreation area, we can still process your passport fast.",
    },
    {
      q: "What if I'm a Boulder City retiree needing a passport for travel?",
      a: "Boulder City has a large and active retiree community. Whether you're planning a European river cruise, Canadian Rockies tour, or visiting family abroad, Fast Passport Center provides fast passport renewal with no office visit required for most adults. Complete your application online and we handle everything — your passport arrives at your door within days.",
    },
    {
      q: "Can I get a passport renewed from Boulder City without driving to Las Vegas?",
      a: "Absolutely. You don't need to drive to Las Vegas, let alone Los Angeles or San Francisco. Fast Passport Center's entire process is done via overnight courier. Complete your application online, we send you a prepaid shipping label, and your new passport is delivered to your Boulder City address within days.",
    },
    {
      q: "How much does expedited passport service cost in Boulder City?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your departure date.",
    },
  ],
  photoLocations: [
    { name: "Boulder City Post Office", address: "1100 Colorado St, Boulder City, NV 89005", hours: "Mon–Fri: 9AM–4PM (photo services by appointment)" },
    { name: "Walgreens — Henderson", address: "601 College Dr, Henderson, NV 89015", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Green Valley", address: "2712 N Green Valley Pkwy, Henderson, NV 89014", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Henderson", address: "10424 S Eastern Ave, Henderson, NV 89052", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Henderson", address: "300 E Lake Mead Pkwy, Henderson, NV 89015", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Henderson", address: "536 N Stephanie St, Henderson, NV 89014", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "Costco — Henderson", address: "791 Marks St, Henderson, NV 89014", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
    { name: "CVS Pharmacy — Boulder Hwy", address: "550 N Boulder Hwy, Henderson, NV 89015", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Nevada DMV — Henderson",
      address: "1399 American Pacific Dr, Henderson, NV 89074",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Closest DMV to Boulder City. REAL ID processing. Online appointment recommended.",
      featured: true,
    },
    {
      name: "Nevada DMV — Sahara (Las Vegas)",
      address: "2701 E Sahara Ave, Las Vegas, NV 89104",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "East Las Vegas location. Alternative if Henderson appointments are full.",
      featured: false,
    },
    {
      name: "Henderson City Hall",
      address: "240 S Water St, Henderson, NV 89015",
      hours: "Mon–Fri: 7:30AM–5:30PM",
      note: "Full-service city government with passport acceptance and extended hours.",
      featured: true,
    },
    {
      name: "Nevada DMV — Flamingo (Las Vegas)",
      address: "8250 W Flamingo Rd, Las Vegas, NV 89147",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "West Las Vegas location. Full services. Alternative for southern Clark County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LAS",
      name: "Harry Reid International Airport",
      distance: "30 miles from Boulder City via I-515/US-95",
      address: "5757 Wayne Newton Blvd, Las Vegas, NV 89119",
      note: "Primary international airport for Boulder City and Southern Nevada. Direct flights to Europe, Asia, Mexico, and Canada. Only 30 minutes from Boulder City via I-515.",
      flightUrl: "https://www.harryreidairport.com/",
      flightLabel: "Harry Reid Airport",
      featured: true,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "300 miles from Boulder City via I-15",
      address: "Los Angeles, CA 90045",
      note: "Major West Coast international hub. Home to the Los Angeles Passport Agency for emergency appointments.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Airport",
      featured: false,
    },
    {
      code: "SFO",
      name: "San Francisco International Airport",
      distance: "550 miles from Boulder City",
      address: "San Francisco, CA 94128",
      note: "Alternative West Coast hub with the San Francisco Passport Agency.",
      flightUrl: "https://www.flysfo.com/",
      flightLabel: "SFO Airport",
      featured: false,
    },
  ],
};